import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import('../views/home/home.vue')//首页
  },
  {
    path: '/layout',
    name: 'layout',
    component: () => import( /* webpackChunkName: 'ImportFuncDemo' */ '@/views/layout/layout.vue'),// 产业布局
  },
  {
    path: '/layout/layoutDetail',
    name: '/layout/layoutDetail',
    component: () => import( /* webpackChunkName: 'ImportFuncDemo' */ '@/views/layout/layoutDetail.vue'),// 产业园详情
  },
  {
    path: '/news',
    name: 'news',
    component: () => import( /* webpackChunkName: 'ImportFuncDemo' */ '@/views/news/news.vue'),// 新闻
  },
  {
    path: '/news/newsDetail',
    name: '/news/newsDetail',
    component: () => import( /* webpackChunkName: 'ImportFuncDemo' */ '@/views/news/newsDetail.vue'),// 新闻详情
  },
  {
    path: '/solicit',
    name: 'solicit',
    component: () => import( /* webpackChunkName: 'ImportFuncDemo' */ '@/views/solicit/solicit.vue'),// 招商
  },
  {
    path: '/solicit/solicitDetail',
    name: '/solicit/solicitDetail',
    component: () => import( /* webpackChunkName: 'ImportFuncDemo' */ '@/views/solicit/solicitDetail.vue'),// 招商详情
  },
  {
    path: '/product',
    name: 'product',
    component: () => import( /* webpackChunkName: 'ImportFuncDemo' */ '@/views/product/product.vue'),// 产品
  },
  {
    path: '/product/productDetail',
    name: '/product/productDetail',
    component: () => import( /* webpackChunkName: 'ImportFuncDemo' */ '@/views/product/productDetail.vue'),// 产品详情
  },
  {
    path: '/contact',
    name: '/contact',
    component: () => import( /* webpackChunkName: 'ImportFuncDemo' */ '@/views/contact/contact.vue'),// 联系我们
  },
  {
    path: '/personalCenter',
    name: '/personalCenter',
    component: () => import( /* webpackChunkName: 'ImportFuncDemo' */ '@/views/personalCenter/personalCenter.vue'),// 个人中心
  },
  {
    path: '/personalCenter/createOrder',
    name: '/personalCenter/createOrder',
    component: () => import( /* webpackChunkName: 'ImportFuncDemo' */ '@/views/personalCenter/createOrder.vue'),// 创建订单
  },
  {
    path: '/personalCenter/orderDetail',
    name: '/personalCenter/orderDetail',
    component: () => import( /* webpackChunkName: 'ImportFuncDemo' */ '@/views/personalCenter/orderDetail.vue'),// 订单详情
  },
  {
    path: '/personalCenter/agreement',
    name: '/personalCenter/agreement',
    component: () => import( /* webpackChunkName: 'ImportFuncDemo' */ '@/views/personalCenter/agreement.vue'),// 协议
  }
]

const router = new VueRouter({
  mode: 'hash',//hash history
  base: process.env.BASE_URL,
  routes
})
// 全局前置守卫
router.beforeEach((to, from, next) => {
  // 检查目标路由是否与当前路由相同（包括查询参数和哈希）
  if (to.path === from.path && to.query === from.query && to.hash === from.hash) {
    // 如果相同，则不执行跳转，可以显示一个提示或者做其他处理
    alert('Cannot navigate to the same route.');
    next(false); // 阻止导航
  } else {
    // 如果不同，则允许导航
    next();
  }
});

export default router
